import React from "react";

import WordGame from "./views/wordGame";

function App() {
  return <WordGame />;
}

export default App;
